<template>
  <div class="mainfooter _mainfooter">
    <div class="footerbody _footerbody">
      <h1 class="rights">©2026 Nook. All rights reserved.</h1>
      <div class="privacy-agreement">
        <div class="privacy" @click="routerpush('/privacy')">{{ $t('privacy.title') }}</div>
        <div class="agreement" @click="routerpush('/agreement')">{{ $t('agreement.title') }}</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'mainfooter',
  components: {
  },
  methods: {
    routerpush (to) {
      this.$router.push(to)
    }
  }
}
</script>

<style lang="less" scoped>
  .mainfooter{
      width: 100%;
      height: 100%;
      background: #050505;
      .footerbody{
          display: flex;
          padding: 1.25rem 0;
          margin:0 5%;
          font-family: 'Plus Jakarta Sans';
          font-style: normal;
          font-weight: 600;
          font-size: 1.375rem;
          line-height: 150%;
          .rights{
            justify-content: flex-start;
            display: flex;
            color: #FFFFFF;
            font-size: 1.375rem;
            font-weight:600;
            margin: 0.4375rem 0;
          }
          .privacy-agreement{
            flex:1;
            justify-content: flex-end;
            display: flex;
            color: #FFFFFF;
            font-size: 1.375rem;
            font-weight:600;
            margin: 0.4375rem 0;
            .privacy{
              margin-left: 0.625rem;
            }
            .agreement{
              margin-left: 3.125rem;
            }
          }
      }
  }
  @media only screen and (max-width: 500px) {
    .mainfooter {
      height: 70px;
      .footerbody {
        padding: 0 0;
        padding-top: 20px;
        font-size: 8px;
        .rights{
          font-size: 8px;
        }
        .privacy-agreement{
          font-size: 8px;
          .privacy{
            margin-left: 0px;
          }
          .agreement{
            margin-left: 10px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Other/Footer.vue